import Navbar from "../components/Navbar"
import SettingsCard from "../components/SettingsCard"

const Settings = () => {
    return (
        <div>
            <Navbar />
            <SettingsCard />
        </div>
    );
};

export default Settings;